import freud from '../images/icons/freud.png';
import logo from '../front-novo/header/logo.svg';
import footLogo from '../front-novo/footer/logo.svg';
import homeBg1 from '../front-novo/home/bg1.jpg';
import homeBg2 from '../front-novo/home/bg2.jpg';
import aboutBg2 from '../front-novo/about/bg1.png';
import aboutBg3 from '../front-novo/about/bg.png';
import homeBg4 from '../front-novo/home/bg4.png';
import homeBg6 from '../front-novo/home/bg6.png';
import virginia from '../front-novo/biblioteca/bg1.png';
import contactBg from '../front-novo/contact/bg1.png';
import eventsBg1 from '../front-novo/events/bg1.jpg';
import servicesBg1 from '../front-novo/services/bg1.png';
import logowhite from '../images/icons/logowhite.png';
import logoblack from '../images/icons/logoblack.png';
import aboutBgMobile from '../front-novo/about/bg2.png';
import formacao from '../front-novo/formacao/bg1.jpg';

// aboutBgMobile

export const light = {
  theme: 'light',
  border: '#250A0D9f',
  font1: '#543530', // Nova cor para segunda fonte
  font2: '#483D39', // Nova cor para primeira fonte
  font3: '#A04330', // Mantendo a cor da terceira fonte
  font4: '#FFFFFF', // Mantendo a cor da terceira fonte
  background1: '#FFFFFF', // Nova cor para o primeiro fundo
  background2: '#FFFFFF', // Nova cor para o segundo fundo
  background3: '#E7A044', // Nova cor para o segundo fundo
  background4: '#EEE4DA',
  background5: '#BD8F6E',
  moon: freud,
  logo: logo,
  virginia: virginia,
  headerBottom: '#BD8F6E',
  footBg: '#483D39',
  footFont: '#EEE4DA',
  footLogo: footLogo,
  homeBg1: homeBg1,
  homeBg4: homeBg4,
  aboutBg2: aboutBg2,
  aboutBgMobile: aboutBgMobile,
  homeBg2: homeBg2,
  aboutBg3: aboutBg3,
  homeBg6: homeBg6,
  eventsBg1: eventsBg1,
  formacao: formacao,
  servicesBg1: servicesBg1,
  contactBg: contactBg,
  logoblack: logoblack,
};

export const dark = light;
